import React from "react";

export const Share = () => {
  return (
    <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M18.6146 0.03125C17.6421 0.03125 16.7095 0.417558 16.0219 1.10519C15.3342 1.79282 14.9479 2.72546 14.9479 3.69792C14.9496 3.95565 14.9784 4.2125 15.0339 4.46419L6.70866 8.62679C6.36529 8.23148 5.94125 7.91429 5.46504 7.69657C4.98884 7.47885 4.47153 7.36565 3.94792 7.36458C2.97546 7.36458 2.04282 7.75089 1.35519 8.43853C0.667558 9.12616 0.28125 10.0588 0.28125 11.0312C0.28125 12.0037 0.667558 12.9363 1.35519 13.624C2.04282 14.3116 2.97546 14.6979 3.94792 14.6979C4.47169 14.6973 4.98927 14.5845 5.46579 14.3671C5.94231 14.1497 6.36672 13.8327 6.71045 13.4375L15.0303 17.5983C14.976 17.8501 14.9484 18.107 14.9479 18.3646C14.9479 19.337 15.3342 20.2697 16.0219 20.9573C16.7095 21.6449 17.6421 22.0312 18.6146 22.0312C19.587 22.0312 20.5197 21.6449 21.2073 20.9573C21.8949 20.2697 22.2812 19.337 22.2812 18.3646C22.2812 17.3921 21.8949 16.4595 21.2073 15.7719C20.5197 15.0842 19.587 14.6979 18.6146 14.6979C18.0908 14.6985 17.5732 14.8113 17.0967 15.0287C16.6202 15.2461 16.1958 15.5631 15.8521 15.9583L7.53223 11.7975C7.58652 11.5457 7.61413 11.2889 7.61458 11.0312C7.61282 10.7741 7.58402 10.5179 7.52865 10.2668L15.8538 6.10417C16.1974 6.49915 16.6215 6.816 17.0977 7.03341C17.5739 7.25082 18.0911 7.36374 18.6146 7.36458C19.587 7.36458 20.5197 6.97828 21.2073 6.29064C21.8949 5.60301 22.2812 4.67038 22.2812 3.69792C22.2812 2.72546 21.8949 1.79282 21.2073 1.10519C20.5197 0.417558 19.587 0.03125 18.6146 0.03125Z"
        fill="url(#paint0_linear_2113_107614)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_2113_107614"
          x1="0.28125"
          y1="11.0312"
          x2="22.2812"
          y2="11.0312"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#605DAF" />
          <stop offset="1" stop-color="#716EC6" />
        </linearGradient>
      </defs>
    </svg>
  );
};
